// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3l9kQ","title":"ClientCherryInfo_title__1Ypph","itemText":"ClientCherryInfo_itemText__2tydE"};